import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconMapMarkerRoundFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.998 10.4c0-4.026 3.074-7.4 7-7.4s7 3.374 7 7.4c0 1.794-.665 3.393-1.614 4.855-.943 1.452-2.21 2.834-3.487 4.189l-.022.024c-.185.196-.364.386-.527.533-.178.16-.406.334-.71.436a1.99 1.99 0 0 1-1.28 0 2.03 2.03 0 0 1-.71-.436c-.162-.147-.34-.337-.526-.533l-.023-.024c-1.276-1.355-2.544-2.737-3.486-4.189-.95-1.462-1.615-3.06-1.615-4.856Zm7.003 1.599a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconMapMarkerRoundFill);
export default Memo;
